import axiosInstance from '../../../services/axios/axios';
import { then } from '../../../services/axios/_utility';
import { SiteRequest, SponsorPayload } from './_classes';
import { WrapImsPacket } from 'store/utility';

/**
 * Retrieves an EpicCare Link site request by message ID.
 * @param {number} id message ID of site request.
 * @param {Function} [dispatch=] forwarded Redux store's method for dispatching actions.
 * @returns {Promise<SiteRequest>} nullable site request details.
 */
export const getSite = async (id, dispatch = null) => {
	try {
		return axiosInstance
			.get(`/api/Utilities/EpicCareLink/Site?id=${id}`)
			.then(response =>
				then(response, payload => new SiteRequest(payload), dispatch),
			);
	} catch (ex) {
		throw ex;
	}
};

/**
 * Retrieves an EpicCare Link site request by message ID.
 * @
 * @param {number} id message ID of site request.
 * @param {Function} [dispatch=] forwarded Redux store's method for dispatching actions.
 * @returns {Promise<SiteRequest>} nullable site request details.
 */
export const getSiteDetails = async (id, dispatch = null) => {
	try {
		return axiosInstance
			.get(`/api/Utilities/EpicCareLink/SiteDetails?id=${id}`)
			.then(response =>
				then(response, payload => new SiteRequest(payload), dispatch),
			);
	} catch (ex) {
		throw ex;
	}
};

/**
 * Posts association between EpicCare Link site and UPMC sponsor.
 * @param {SponsorPayload} payload form payload.
 * @param {Function} [dispatch=] forwarded Redux store's method for dispatching actions.
 * @returns {Promise<boolean>} success indicator.
 */
export const postAssociation = async (payload, dispatch = null) => {
	try {
		return axiosInstance
			.post(`/api/Utilities/EpicCareLink/Site`, payload)
			.then(response => then(response, payload => payload, dispatch));
	} catch (ex) {
		throw ex;
	}
};

export const submitLinkSiteAdminCompletion = async (
	payload,
	trackingNumber,
	dispatch = null,
) => {
	try {
		return axiosInstance
			.post(
				`/api/Utilities/EpicCareLink/SiteAdminComplete/${trackingNumber}`,
				WrapImsPacket({
					...payload.thirdPartyOrganization,
				}),
			)
			.then(response => then(response, payload => payload, dispatch));
	} catch (ex) {
		throw ex;
	}
};

export const checkTrackingNumber = async (trackingNumber, dispatch = null) => {
	try {
		return axiosInstance
			.get(
				`/api/Utilities/EpicCareLink/CheckSiteAdminTrackingNumber/${trackingNumber}`,
			)
			.then(response => then(response, payload => payload, dispatch));
	} catch (ex) {
		throw ex;
	}
};
